import { Chart, PointElement, LineElement, TimeScale, Colors, Legend } from 'chart.js';
import { Line } from 'react-chartjs-2';
import React from 'react';
import 'chartjs-adapter-moment';

Chart.register(PointElement, LineElement, TimeScale, Colors, Legend);

const SubscriptionsChart = ({
  subscriptionsData = [],
  height = '350px',
  showTitle = true,
  showLegend = true,
}) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      colors: {
        enabled: true,
      },
      title: {
        display: showTitle,
        text: 'Rostered Subscribers',
      },
      legend: {
        display: showLegend,
      },
      tooltip: {
        mode: 'index',
        axis: 'y',
        callbacks: {
          title: (items) => {
            let value = items[0]?.raw?.x;
            if (value) return value.format('MMM YYYY');
          },
        },
      },
    },
    scales: {
      x: {
        type: 'time',
        time: {
          unit: 'month',
        },
      },
    },
  };

  const data = {
    datasets: subscriptionsData.map((d) => {
      return {
        label: d.label,
        data: d.values,
      };
    }),
  };

  return (
    <div className="chart" style={{ height }}>
      <Line data={data} options={options} />
    </div>
  );
};

export default SubscriptionsChart;
